var React = require('react');

function HeartCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M248,8C111,8,0,119,0,256S111,504,248,504,496,393,496,256,385,8,248,8ZM371.5,280.3,260.9,394.5a17.88,17.88,0,0,1-25.28.62h0c-.21-.2-.42-.41-.62-.62L124.5,280.3c-32.1-33.2-30.2-88.2,5.7-118.8,31.3-26.7,77.9-21.9,106.6,7.7l11.3,11.6,11.3-11.6c28.7-29.6,75.3-34.4,106.6-7.7,35.8,30.6,37.7,85.6,5.5,118.8Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M371.5,280.3,260.9,394.5a17.88,17.88,0,0,1-25.28.62h0c-.21-.2-.42-.41-.62-.62L124.5,280.3c-32.1-33.2-30.2-88.2,5.7-118.8,31.3-26.7,77.9-21.9,106.6,7.7l11.3,11.6,11.3-11.6c28.7-29.6,75.3-34.4,106.6-7.7,35.8,30.6,37.7,85.6,5.5,118.8Z","className":"fa-primary","key":2})]);
}

HeartCircle.defaultProps = {"viewBox":"0 0 496 512","className":"icon"};

module.exports = HeartCircle;

HeartCircle.default = HeartCircle;
